import numeral from 'numeral'

export const numeralConfig = {
  delimiters: {
    thousands: '.',
    decimal: ','
  },
  abbreviations: {
    thousand: 'k',
    million: 'm',
    billion: 'b',
    trillion: 't'
  },
  ordinal: function (number) {
    return number === 1 ? 'er' : 'ème'
  },
  currency: {
    symbol: '₺'
  }
}

export const validateMessages = {
  required: 'Bu alanı doldurunuz',
  types: {
    email: 'Lütfen geçerli bir mail adresi giriniz.',
    number: 'Lütfen geçerli bir rakkam giriniz!'
  },
  number: {
    // eslint-disable-next-line no-template-curly-in-string
    min: 'Tutar ${min} dan daha az olamaz'
  }
}

export const animatedNumberConfig = (fontSize) => ({
  style: {
    transition: '0.8s ease-out',
    transitionProperty:
            'background-color, color, opacity'
  },
  frameStyle: perc => (
    perc === 100 ? {} : {
      fontSize
    }
  ),
  duration: 300,
  formatValue: n => numeral(n).format('0,0[.]00 $')
})

export const defaultPaymentTypes =  [
  {
    key: 'cash',
    name: 'Nakit'
  },
  {
    key: 'creditcard',
    name: 'Kredi Kartı'
  },
  {
    key: 'sodexo',
    name: 'Sodexo'
  },
  {
    key: 'sodexomobil',
    name: 'Sodexo Mobil'
  },
  {
    key: 'ticket',
    name: 'Edenred Ticket'
  },
  {
    key: 'setcard',
    name: 'SetCard'
  },
  {
    key: 'multinet',
    name: 'Multinet'
  },
  {
    key: 'metropol',
    name: 'MetropolCard'
  },
  {
    key: 'paye',
    name: 'Paye Kart'
  },
  {
    key: 'yemekmatik',
    name: 'Yemekmatik'
  },
  {
    key: 'winwin',
    name: 'WinWin'
  }
]

export const countryNames = {
  Andorra: 'Andorra',
  'United Arab Emirates': 'Birleşik Arap Emirlikleri',
  Afghanistan: 'Afganistan',
  'Antigua & Barbuda': 'Antigua ve Barbuda',
  Anguilla: 'Anguilla',
  Albania: 'Arnavutluk',
  Armenia: 'Ermenistan',
  Angola: 'Angola',
  Antarctica: 'Antarktika',
  Argentina: 'Arjantin',
  'American Samoa': 'Amerikan Samoası',
  Austria: 'Avusturya',
  Australia: 'Avustralya',
  Aruba: 'Aruba',
  'Åland Islands': 'Åland Adaları',
  Azerbaijan: 'Azerbaycan',
  'Bosnia & Herzegovina': 'Bosna-Hersek',
  Barbados: 'Barbados',
  Bangladesh: 'Bangladeş',
  Belgium: 'Belçika',
  'Burkina Faso': 'Burkina Faso',
  Bulgaria: 'Bulgaristan',
  Bahrain: 'Bahreyn',
  Burundi: 'Burundi',
  Benin: 'Benin',
  'St. Barthélemy': 'Saint Barthelemy',
  Bermuda: 'Bermuda',
  Brunei: 'Brunei',
  Bolivia: 'Bolivya',
  'Caribbean Netherlands': 'Karayip Hollandası',
  Brazil: 'Brezilya',
  Bahamas: 'Bahamalar',
  Bhutan: 'Butan',
  'Bouvet Island': 'Bouvet Adası',
  Botswana: 'Botsvana',
  Belarus: 'Belarus',
  Belize: 'Belize',
  Canada: 'Kanada',
  'Cocos (Keeling) Islands': 'Cocos (Keeling) Adaları',
  'Congo - Kinshasa': 'Kongo - Kinşasa',
  'Central African Republic': 'Orta Afrika Cumhuriyeti',
  'Congo - Brazzaville': 'Kongo - Brazavil',
  Switzerland: 'İsviçre',
  'Côte d’Ivoire': 'Côte d’Ivoire',
  'Cook Islands': 'Cook Adaları',
  Chile: 'Şili',
  Cameroon: 'Kamerun',
  China: 'Çin',
  Colombia: 'Kolombiya',
  'Costa Rica': 'Kosta Rika',
  Cuba: 'Küba',
  'Cape Verde': 'Cape Verde',
  Curaçao: 'Curaçao',
  'Christmas Island': 'Christmas Adası',
  Cyprus: 'Kıbrıs',
  Czechia: 'Çekya',
  Germany: 'Almanya',
  Djibouti: 'Cibuti',
  Denmark: 'Danimarka',
  Dominica: 'Dominika',
  'Dominican Republic': 'Dominik Cumhuriyeti',
  Algeria: 'Cezayir',
  Ecuador: 'Ekvador',
  Estonia: 'Estonya',
  Egypt: 'Mısır',
  'Western Sahara': 'Batı Sahra',
  Eritrea: 'Eritre',
  Spain: 'İspanya',
  Ethiopia: 'Etiyopya',
  Finland: 'Finlandiya',
  Fiji: 'Fiji',
  'Falkland Islands': 'Falkland Adaları',
  Micronesia: 'Mikronezya',
  'Faroe Islands': 'Faroe Adaları',
  France: 'Fransa',
  Gabon: 'Gabon',
  'United Kingdom': 'Birleşik Krallık',
  Grenada: 'Grenada',
  Georgia: 'Gürcistan',
  'French Guiana': 'Fransız Guyanası',
  Guernsey: 'Guernsey',
  Ghana: 'Gana',
  Gibraltar: 'Cebelitarık',
  Greenland: 'Grönland',
  Gambia: 'Gambiya',
  Guinea: 'Gine',
  Guadeloupe: 'Guadeloupe',
  'Equatorial Guinea': 'Ekvator Ginesi',
  Greece: 'Yunanistan',
  'South Georgia & South Sandwich Islands': 'Güney Georgia ve Güney Sandwich Adaları',
  Guatemala: 'Guatemala',
  Guam: 'Guam',
  'Guinea-Bissau': 'Gine-Bissau',
  Guyana: 'Guyana',
  'Hong Kong SAR China': 'Çin Hong Kong ÖİB',
  'Heard & McDonald Islands': 'Heard Adası ve McDonald Adaları',
  Honduras: 'Honduras',
  Croatia: 'Hırvatistan',
  Haiti: 'Haiti',
  Hungary: 'Macaristan',
  Indonesia: 'Endonezya',
  Ireland: 'İrlanda',
  Israel: 'İsrail',
  'Isle of Man': 'Man Adası',
  India: 'Hindistan',
  'British Indian Ocean Territory': 'Britanya Hint Okyanusu Toprakları',
  Iraq: 'Irak',
  Iran: 'İran',
  Iceland: 'İzlanda',
  Italy: 'İtalya',
  Jersey: 'Jersey',
  Jamaica: 'Jamaika',
  Jordan: 'Ürdün',
  Japan: 'Japonya',
  Kenya: 'Kenya',
  Kyrgyzstan: 'Kırgızistan',
  Cambodia: 'Kamboçya',
  Kiribati: 'Kiribati',
  Comoros: 'Komorlar',
  'St. Kitts & Nevis': 'Saint Kitts ve Nevis',
  'North Korea': 'Kuzey Kore',
  'South Korea': 'Güney Kore',
  Kuwait: 'Kuveyt',
  'Cayman Islands': 'Cayman Adaları',
  Kazakhstan: 'Kazakistan',
  Laos: 'Laos',
  Lebanon: 'Lübnan',
  'St. Lucia': 'Saint Lucia',
  Liechtenstein: 'Liechtenstein',
  'Sri Lanka': 'Sri Lanka',
  Liberia: 'Liberya',
  Lesotho: 'Lesotho',
  Lithuania: 'Litvanya',
  Luxembourg: 'Lüksemburg',
  Latvia: 'Letonya',
  Libya: 'Libya',
  Morocco: 'Fas',
  Monaco: 'Monako',
  Moldova: 'Moldova',
  Montenegro: 'Karadağ',
  'St. Martin': 'Saint Martin',
  Madagascar: 'Madagaskar',
  'Marshall Islands': 'Marshall Adaları',
  'North Macedonia': 'Kuzey Makedonya',
  Mali: 'Mali',
  'Myanmar (Burma)': 'Myanmar (Burma)',
  Mongolia: 'Moğolistan',
  'Macao SAR China': 'Çin Makao ÖİB',
  'Northern Mariana Islands': 'Kuzey Mariana Adaları',
  Martinique: 'Martinik',
  Mauritania: 'Moritanya',
  Montserrat: 'Montserrat',
  Malta: 'Malta',
  Mauritius: 'Mauritius',
  Maldives: 'Maldivler',
  Malawi: 'Malavi',
  Mexico: 'Meksika',
  Malaysia: 'Malezya',
  Mozambique: 'Mozambik',
  Namibia: 'Namibya',
  'New Caledonia': 'Yeni Kaledonya',
  Niger: 'Nijer',
  'Norfolk Island': 'Norfolk Adası',
  Nigeria: 'Nijerya',
  Nicaragua: 'Nikaragua',
  Netherlands: 'Hollanda',
  Norway: 'Norveç',
  Nepal: 'Nepal',
  Nauru: 'Nauru',
  Niue: 'Niue',
  'New Zealand': 'Yeni Zelanda',
  Oman: 'Umman',
  Panama: 'Panama',
  Peru: 'Peru',
  'French Polynesia': 'Fransız Polinezyası',
  'Papua New Guinea': 'Papua Yeni Gine',
  Philippines: 'Filipinler',
  Pakistan: 'Pakistan',
  Poland: 'Polonya',
  'St. Pierre & Miquelon': 'Saint Pierre ve Miquelon',
  'Pitcairn Islands': 'Pitcairn Adaları',
  'Puerto Rico': 'Porto Riko',
  'Palestinian Territories': 'Filistin Bölgeleri',
  Portugal: 'Portekiz',
  Palau: 'Palau',
  Paraguay: 'Paraguay',
  Qatar: 'Katar',
  Réunion: 'Reunion',
  Romania: 'Romanya',
  Serbia: 'Sırbistan',
  Russia: 'Rusya',
  Rwanda: 'Ruanda',
  'Saudi Arabia': 'Suudi Arabistan',
  'Solomon Islands': 'Solomon Adaları',
  Seychelles: 'Seyşeller',
  Sudan: 'Sudan',
  Sweden: 'İsveç',
  Singapore: 'Singapur',
  'St. Helena': 'Saint Helena',
  Slovenia: 'Slovenya',
  'Svalbard & Jan Mayen': 'Svalbard ve Jan Mayen',
  Slovakia: 'Slovakya',
  'Sierra Leone': 'Sierra Leone',
  'San Marino': 'San Marino',
  Senegal: 'Senegal',
  Somalia: 'Somali',
  Suriname: 'Surinam',
  'South Sudan': 'Güney Sudan',
  'São Tomé & Príncipe': 'Sao Tome ve Principe',
  'El Salvador': 'El Salvador',
  'Sint Maarten': 'Sint Maarten',
  Syria: 'Suriye',
  Eswatini: 'Esvatini',
  'Turks & Caicos Islands': 'Turks ve Caicos Adaları',
  Chad: 'Çad',
  'French Southern Territories': 'Fransız Güney Toprakları',
  Togo: 'Togo',
  Thailand: 'Tayland',
  Tajikistan: 'Tacikistan',
  Tokelau: 'Tokelau',
  'Timor-Leste': 'Timor-Leste',
  Turkmenistan: 'Türkmenistan',
  Tunisia: 'Tunus',
  Tonga: 'Tonga',
  Turkey: 'Türkiye',
  'Trinidad & Tobago': 'Trinidad ve Tobago',
  Tuvalu: 'Tuvalu',
  Taiwan: 'Tayvan',
  Tanzania: 'Tanzanya',
  Ukraine: 'Ukrayna',
  Uganda: 'Uganda',
  'U.S. Outlying Islands': 'ABD Küçük Harici Adaları',
  'United States': 'Amerika Birleşik Devletleri',
  Uruguay: 'Uruguay',
  Uzbekistan: 'Özbekistan',
  'Vatican City': 'Vatikan',
  'St. Vincent & Grenadines': 'Saint Vincent ve Grenadinler',
  Venezuela: 'Venezuela',
  'British Virgin Islands': 'Britanya Virjin Adaları',
  'U.S. Virgin Islands': 'ABD Virjin Adaları',
  Vietnam: 'Vietnam',
  Vanuatu: 'Vanuatu',
  'Wallis & Futuna': 'Wallis ve Futuna',
  Samoa: 'Samoa',
  Yemen: 'Yemen',
  Mayotte: 'Mayotte',
  'South Africa': 'Güney Afrika',
  Zambia: 'Zambiya',
  Zimbabwe: 'Zimbabve'
}

export const fontList = ['Roboto',  'Open Sans',
  'Lato',
  'Oswald',
  'Slabo 27 px',
  'Roboto Condensed',
  'Abril Fatface',
  'Montserrat',
  'Source Sans Pro',
  'Raleway',
  'PT Sans',
  'Playfair Display',
  'Bitter',
  'Libre Baskerville',
  'Archivo Narrow',
  'Alegreya Sans',
  'Ubuntu',
  'Crimson Text',
  'Heebo',
  'Cabin',
  'Abril Fatface',
  'Barlow',
  'Bree Serif',
  'Ropa Sans',
  'Amiri',
  'Zilla Slab',
  'Great Vibes',
  'Cantata One',
  'Roboto Slab',
  'Cardo',
  'Poppins',
  'Lora',
  'Karla',
  'Slabo 27px',
  'EB Garamond',
  'Josefin Slab',
  'Unna',
  'Abhaya Libre',
  'Roboto ',
  'Rubik',
  'Asap',
  'Indie Flower',
  'Shadows Into Light',
  'Amatic SC',
  'Architects Daughter',
  'Nothing You Could Do',
  'Reenie Beanie',
  'Sue Ellen Francisco',
  'Squada One',
  'Bahianiata ',
  'Mountains of Christmas',
  'Righteous',
  'Comfortaa',
  'Patua One',
  'Roboto Mono',
  'Inconsolata',
  'Source Code Pro',
  'Cousine',
  'PT Mono',
  'Nanum Gothic Coding',
  'Space Mono',
  'Anonymous Pro',
  'Cutive Mono',
  'Oxygen Mono',
  'Literata',
  'Libre Franklin',
  'Muli',
  'Exo',
  'Overpass',
  'Segoe UI',
  'Palanquin Dark',
  'Bebas Neue',
  'Josefin Sans']
